import * as React from "react";
import { connect } from "react-redux";

import { MetaTags } from "../../../head";
import http from "../../../helpers/http";
import { history } from "../../../store";
import { Category, Product } from "../../../models";
import { RootState, Dispatch } from "../../../store/types";
import { LoadingSpinner, Wrapper } from "../../../components";
import Step1 from "./Step1";
import CategoryItem from "./CategoryItem";
import ProductItem from "./ProductItem";
import { Step1State } from "../reducer";
import * as actions from "../actions";
import * as selectors from "../selectors";
import * as constants from "../constants";
import {
  actions as searchActions,
  selectors as searchSelectors,
  State as SearchState,
} from "../../ProductSearch";
import { PhoneInputFormValues } from "./PhoneInputForm";

export interface PhonePrefixOption {
  value: string;
  text: string;
}

export interface Step1ContainerProps extends Step1State, SearchState {
  phonePrefixOpts?: PhonePrefixOption[];
  fetchCategories: () => void;
  chooseCategory: (c: Category) => () => void;
  chooseProduct: (p: Product) => () => void;
}

interface Step1ContainerState {
  isShowingModal: boolean;
}

// TODO: most of these private methods/property fns are state derivations; should go in selector,
//  but TS makes it difficult because the type changes, and I don't get how to add little extra fields
// without extending yet
class Step1Container extends React.Component<
  Step1ContainerProps,
  Step1ContainerState
> {
  public state: Step1ContainerState = {
    isShowingModal: false,
  };

  public static defaultProps: Partial<Step1ContainerProps> = {
    phonePrefixOpts: constants.PHONE_PREFIX_OPTS,
  };

  public componentDidMount(): void {
    this.props.fetchCategories();
  }

  public render() {
    return (
      <Wrapper>
        <MetaTags title="Danh sách sản phẩm" />
        <Step1
          {...this.props}
          {...this.state}
          categoryItems={this.renderCategoryItems()}
          productItems={this.renderProductItems()}
          productSearchHook={this.productSearchHook}
          phonePrefixOptions={this.renderPhonePrefixOptions()}
          handlePhoneInputSubmit={this.handlePhoneInputSubmit}
          handleClosePhoneInputModal={this.toggleClosePhoneInputModal}
        />
      </Wrapper>
    );
  }

  // TODO: need to render diff view for empty search
  private renderProductItems() {
    if (this.props.isSuggestionsLoading) {
      return <LoadingSpinner large />;
    }

    return this.props.suggestions.map(product => (
      <ProductItem
        {...product}
        key={product.id}
        onClick={this.props.chooseProduct(product)}
        active={this.checkProductActiveState(product)}
      />
    ));
  }

  private renderCategoryItems() {
    if (this.props.isCategoriesLoading) {
      return <LoadingSpinner large />;
    }

    return this.props.categories.map(category => (
      <CategoryItem
        {...category}
        key={category.id}
        onClick={this.props.chooseCategory(category)}
        active={this.checkCategoryActiveState(category)}
      />
    ));
  }

  private renderPhonePrefixOptions = () =>
    (this.props.phonePrefixOpts as PhonePrefixOption[]).map((option, i) => (
      <option key={i} value={option.value}>
        {option.text}
      </option>
    ));

  private handlePhoneInputSubmit = async (values: PhoneInputFormValues) => {
    const { success }: any = await http.post(
      constants.FORMSPREE_ENQUIRY_ACTION,
      values,
    );
    if (success) {
      this.toggleClosePhoneInputModal();
    }
  };

  private toggleClosePhoneInputModal = () => {
    this.setState(state => ({
      ...state,
      isShowingModal: !state.isShowingModal,
    }));
  };

  private checkCategoryActiveState = (category: Category): boolean =>
    this.props.chosenCategory
      ? this.props.chosenCategory.id === category.id
      : false;

  private checkProductActiveState = (product: Product): boolean =>
    this.props.chosenProduct
      ? this.props.chosenProduct.id === product.id
      : false;

  // Move to step 1-2 on search, else if empty search go back to step 1-1
  private productSearchHook = (input: HTMLInputElement) =>
    history.replace(input.value ? "/wizard/step-1/products" : "/wizard/step-1");
}

const mapStateToProps = (state: RootState): Partial<Step1ContainerProps> => ({
  // Local state
  categories: selectors.categories(state),
  isCategoriesLoading: selectors.isCategoriesLoading(state),
  chosenCategory: selectors.chosenCategory(state),
  chosenProduct: selectors.chosenProduct(state),
  // Search state
  suggestions: searchSelectors.suggestions(state),
  isSuggestionsLoading: searchSelectors.isSuggestionsLoading(state),
});

const mapDispatchToProps = (
  dispatch: Dispatch,
): Partial<Step1ContainerProps> => ({
  // Local state mutators
  fetchCategories: () => dispatch(actions.fetchCategories()),

  // Step 1-1 choice
  chooseCategory: (category: Category) => () => {
    dispatch(
      searchActions.searchProducts(
        undefined,
        Number.MAX_SAFE_INTEGER, // Always want all results (for now)
        category,
      ),
    );
    history.replace("/wizard/step-1/products"); // Go to products choice view
  },

  // Step 1-2 choice
  chooseProduct: (product: Product) => () => {
    dispatch(actions.chooseProduct(product));
    history.replace(`/wizard/step-1/products/${product.id}`); // Go to product review
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Step1Container);



// WEBPACK FOOTER //
// ./src/routes/Step1/components/Step1Container.tsx